export enum PermissionEnum {
    Admin = 'Admin',
    Customer = 'Customer',
    CustomerService = 'Customer Service',
}
